var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m2n-logo my-5 font-size-12 text-uppercase text-muted text-center"},[_c('a',{staticClass:"text-muted font-size-11",attrs:{"target":"_blank","href":"https://m2n.com.br/?utm_source=mycapsulife.com.br&utm_medium=link&utm_campaign=logo"}},[_vm._v(" TECNOLOGIA POR M2N ")])])
}]

export { render, staticRenderFns }